import React, { useContext, useEffect, useState } from "react";
import Title from "../Title/Title";
import LineChart from "../Chart/LineChart";
import { dataToAhead } from "../../Helper/bigTableDates";
import AheadTable from "../Table/AheadTable";
import Table from "../Table/Table";
import overviewCards from "../Overview/OverviewCard/OverviewDummy";
import ButtonSelect from "../ButtonSelect/ButtonSelect";
import { FlinkContext } from "../../context/FlinkContext";
import Loading from "../Loading/Loading";
import HistoricalModal from "../HistoricalModal/HistoricalModal";
import BigTable from "../Table/BigTable";
import "./Content.scss";
import Logger from "../../Helper/Logger";

function FlinkGas() {
  const [spot, setSpot] = useState("Spot");
  const gasData = useContext(FlinkContext);
  const [gas, setGas] = useState(null);
  const [list, setList] = useState(null);
  const [charts, setCharts] = useState([]);
  const [printedCharts, setPrintedCharts] = useState(null);

  useEffect(() => {
    setGas(gasData.gas);
  }, [gasData]);

  useEffect(() => {
    if (gas?.forwardChart) {
      setList([
        ...gas?.forwardChart.map((item) => {
          if (item.marketName === "TTF Y+1") {
            return {
              marketName: item.marketName,
              chart: item.chart,
              cheked: true,
            };
          } else {
            return {
              marketName: item.marketName,
              chart: item.chart,
              cheked: false,
            };
          }
        }),
      ]);
    }
  }, [gas]);
  const spotForward = (value) => {
    if (value === "Spot") {
      setCharts(gas?.spotChart);
    }
    if (value === "Forward") {
      setCharts(list.filter((item) => item.cheked === true));
    }
  };

  useEffect(() => {
    spotForward(spot);
  }, [spot, list]);

  useEffect(() => {
    if (list) {
      setPrintedCharts(list.filter((l) => l.marketName.includes("Y")));
    }
  }, [list]);

  const modalData = [gasData?.gas?.gasTable?.pricesSpotBase];
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div id="gas" className="GrayBox ">
      <div className="Flink-container">
        {gasData?.gas && list && charts ? (
          <>
            <Title title="Gas" icon={overviewCards.gas.icon} />
            <div className="row">
              <Logger op="Chart" id="17149" className="col-md-6 col-sm-12">
                <h5 className="text-center chartTitleP">TTF Gas</h5>
                <div className="d-flex justify-content-center buttonP">
                  <ButtonSelect
                    list={list}
                    onSaveList={setList}
                    onSpot={setSpot}
                  />
                </div>
                <div className="powerPageCharts">
                  <LineChart
                    yAxisTitle="€/MWh"
                    data={charts}
                    colors={[
                      "#004474",
                      "#70cff9",
                      "#75B951",
                      "#B28D2F",
                      "#EC6707",
                      "#73CCF4",
                      "#1B2C56",
                    ]}
                    showLegend
                  />
                </div>
                <div className="powerPrintedCharts">
                  <LineChart
                    yAxisTitle="€/MWh"
                    data={printedCharts}
                    colors={[
                      "#004474",
                      "#70cff9",
                      "#B28D2F",
                      "#EC6707",
                      "#73CCF4",
                      "#1B2C56",
                      "#75B951",
                    ]}
                    showLegend
                  />
                </div>
              </Logger>
              <Logger op="News" id="40110" className="col-md-6 col-sm-12">
                <h5 className="text-center chartTitleP">TTF Gas</h5>
                <AheadTable
                  openModal={setIsOpen}
                  firstThName="Gas"
                  data={[dataToAhead(gasData?.gas?.gasTable?.pricesSpotBase)]}
                />
                <Table
                  noAhead
                  openModal={setIsOpen}
                  revert
                  date2={gas?.gasTable?.date2}
                  date1={gas?.gasTable?.date1}
                  firstThName="Gas"
                  showBtn="none"
                  data={gas?.gasTable?.pricesTable}
                />
              </Logger>
            </div>
            <HistoricalModal open={isOpen} onClose={() => setIsOpen(false)}>
              <BigTable showBtn="none" firstThName="TTF Gas" data={modalData} />
            </HistoricalModal>
          </>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}

export default FlinkGas;
